import React, { useState, useEffect } from "react";
import { txtA, txtE } from "../../../Label/Lbl";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import { useInvAF, useInvMain } from "../../../St/Reviews/UseStyle";
import Paper from "@material-ui/core/Paper";
import { getTotalAmount } from "../../../utils/utils";
import { useBody } from "../../Invs/invCompany/style";
import { ButtonBase } from "@material-ui/core";
import { QRCodeCanvas } from "qrcode.react";


const UnderHeaderD = (props) => {

    const { found, inv, sta, locInv } = props;
    const clasm = useInvMain();
    const clas = useInvAF();
    const [showSc, setShowSc] = useState(true);
    const calssBody = useBody();

    const stylesA = { textAlign: "center", direction: "rtl", fontWeight: "bold", fontSize: "1.1rem", color: "#000" };
    const stylesE = { textAlign: "center", direction: "ltr", fontWeight: "bold", fontSize: "1.1rem", color: "#000" };

    const styf = { fontWeight: "500" };
    const styfC = { fontWeight: "500", color: "#9a3f47" };
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};


    return (
        <Grid
            item
            container

            style={{ fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm", marginRight: "0rem", paddingTop: "0.5rem" }}

        >
            <Grid item xs={12}>

                <Grid item container >

                    {locInv.ProcTypeInvProc != "03" && locInv.ProcTypeInvProc != "04" ?
                        (
                            <Grid item xs={3} container>
                                <Grid item xs={2}></Grid>
                                <Grid item xs={9}>
                                    {(locInv?.Step_inv2 && inv?.ZatcaQR) ? (
                                        <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, }}>
                                            {
                                                <QRCodeCanvas value={inv?.ZatcaQR} />
                                            }

                                        </ButtonBase>
                                    )
                                        : (
                                            <ButtonBase
                                                style={{ border: "solid 1px" }}
                                            >
                                                {
                                                    <img
                                                        src={`data:image/jpeg;base64,${inv.qr_image}`}
                                                        style={{ height: 120, width: 120, margin: 0, padding: 0 }}
                                                        alt={found.nameA}
                                                    />
                                                }
                                            </ButtonBase>
                                        )}

                                </Grid>
                                <Grid item xs={1}></Grid>

                            </Grid>
                        )
                        :
                        (<Grid item xs={2} container>
                            <Grid item xs={12}></Grid>
                        </Grid>)
                    }
                    <Grid item xs={9} container style={{ alignContent: "right" }}>
                        <Grid item xs={12}></Grid>
                        {locInv.ProcTypeInvProc != "03" && locInv?.ProcTypeInvProc != "04" && (
                            <Grid item xs={12} container>
                                <Grid item xs={11} container className={clas.BdytitleHedMusa}>

                                    <Grid item xs={6} className={clasm.minclr} style={{ textAlign: "center" }}>
                                        <div style={{ textAlign: "center", direction: "rtl", fontWeight: "bold", fontSize: "1.1rem", color: "#000" }}>
                                            {sta.tot.tax_no_cust === ""
                                                ? "Simplified Tax Invoice"
                                                : "Tax Invoice"}
                                        </div>
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minclr} style={{ textAlign: "center" }}>
                                        <div style={{ textAlign: "center", direction: "rtl", fontWeight: "bold", fontSize: "1.1rem", color: "#000" }}>

                                            {sta.tot.tax_no_cust === ""
                                                ? "فاتورة ضريبية مبسطة"
                                                : "فاتورة ضريبية"}
                                        </div>
                                    </Grid>

                                </Grid>

                                <Grid item xs={1}></Grid>
                            </Grid>
                        )}
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12}></Grid>

                        <Grid item xs={12} container>
                            <Grid item container xs={11} className={clas.BdytitleHedMusa}>
                                {premiApp.billTemplate === 17 ?
                                    (
                                        <>
                                            <Grid item xs={6} className={clasm.minclr}>
                                                <div style={{ textAlign: "center", direction: "rtl", fontWeight: "bold", fontSize: "1.1rem", color: "#000" }}>
                                                    {inv.pay_type == 1 ? "نقدية " : inv.pay_type == -1 ? "آجلة" : "شبكة "}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6} className={clasm.minclr}>

                                                <div style={{ direction: "rtl", fontWeight: "bold", fontSize: "1.1rem", color: "#000" }}>
                                                    {"طريقة الدفع" + "      :     "}
                                                </div>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            <Grid item xs={6} className={clasm.minclr}>
                                                <div style={stylesE}>
                                                    {locInv.invNEn}
                                                </div>
                                            </Grid>
                                            <Grid item xs={6} className={clasm.minclr}>
                                                <div style={stylesA}>
                                                    {locInv.invN}
                                                </div>
                                            </Grid>
                                        </>
                                    )}

                            </Grid>
                            <Grid item xs={1}></Grid>
                        </Grid>


                    </Grid>
                    {/* <Grid item xs={2}></Grid> */}
                </Grid>


                <Grid item container style={{ direction: "rtl", paddingTop: "0.5rem" }}>
                    <Grid item xs={12}
                    >
                        <Grid item container className={clasm.mincntr}>
                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP1} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {txtA.invNumr}{":"}
                                    </Grid>
                                    <Grid item xs={6} className={clas.BdyborBtRTOP3} >
                                        <Paper className={clasm.minclr}>{sta.tot.id}</Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP2} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {":"} {"Inv No "}
                                    </Grid>
                                </Grid>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP1} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"التاريخ"}{":"}
                                    </Grid>
                                    <Grid item xs={6} className={clas.BdyborBtRTOP3}>
                                        <Paper className={clasm.minclr}>
                                            <div style={{ fontSize: "1rem", fontWeight: "bold", color: "#000" }}>{moment(sta.tot.date).format("YYYY/MM/DD")}</div>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtRTOP2} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {":"}  {"Date"}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"اسم العميل"}{":"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}>
                                            <div style={{ fontSize: "1rem", fontWeight: "bold", color: "#000" }}>{sta.tot.cust_name}</div></Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {":"} {"Cust Name"}
                                    </Grid>
                                </Grid>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {" رقم الجوال"} {"للعميل"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}>
                                            <div style={{ fontSize: "1rem", fontWeight: "bold", color: "#000" }}>{sta.tot.cust_mobile}</div> </Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {":"}{"Cust No"}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item container xs={12}>
                                <Grid item container xs={6}>
                                    <Grid item xs={4} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {" الرقم الضريبي للعميل"}{":"}
                                    </Grid>
                                    <Grid item xs={4} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}>
                                            <div style={{ fontSize: "1rem", fontWeight: "bold", color: "#000" }}> {sta.tot.tax_no_cust}</div> </Paper>
                                    </Grid>
                                    <Grid item xs={4} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {":"} {"Cust Vat No"}
                                    </Grid>
                                </Grid>

                                <Grid item container xs={6}>
                                    <Grid item xs={3} className={clas.BdyborBtR} style={{ textAlign: "right", paddingRight: 7 }}>
                                        {"عنوان العميل"}{":"}
                                    </Grid>
                                    <Grid item xs={6} className={clasm.minborB}>
                                        <Paper className={clasm.minclr}>
                                            <div style={{ fontSize: "1rem", fontWeight: "bold", color: "#000" }}>  {sta.tot.cust_address}</div></Paper>
                                    </Grid>
                                    <Grid item xs={3} className={clas.BdyborBtL} style={{ textAlign: "left", paddingLeft: 7 }}>
                                        {":"} {"Address"}
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </Grid >
    );
};

export default UnderHeaderD;
